import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";

/**
 * Live impact strip — pulls real counts from /api/impact. The numbers
 * surface ABGN-UK's quiet, accumulating service: members, events held,
 * curriculum chapters published, donations & grants. Honest, never inflated.
 */
const NUMBERS = [
  { key: "members", label: "Community members", suffix: "" },
  { key: "events_held", label: "Dhamma gatherings hosted", suffix: "" },
  { key: "book_chapters_published", label: "Curriculum chapters published", suffix: "" },
  { key: "donations_lifetime_gbp", label: "Donations received", prefix: "£" },
];

export default function ImpactStrip() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/impact").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  return (
    <section className="bg-navy text-pearl py-16" data-testid="home-impact-strip">
      <div className="section-container">
        <div className="max-w-3xl">
          <p className="text-[10px] uppercase tracking-[0.3em] text-saffron">Our quiet ledger</p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl text-pearl">
            Numbers don't tell the whole story — but they tell part of it.
          </h2>
          <p className="mt-3 text-pearl/70 text-sm sm:text-base max-w-2xl">
            Every figure below is generated live from our records. We publish what we actually
            do, never what we plan to do.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {NUMBERS.map((n, i) => {
            const raw = Number(data[n.key] || 0);
            return (
              <motion.div
                key={n.key}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="border-l-2 border-saffron pl-5"
                data-testid={`impact-${n.key}`}
              >
                <div className="font-display text-4xl sm:text-5xl text-saffron tabular-nums tracking-tight">
                  {n.prefix || ""}
                  {raw.toLocaleString("en-GB", { maximumFractionDigits: 0 })}
                  {n.suffix || ""}
                </div>
                <p className="mt-2 text-pearl/65 text-sm leading-snug">{n.label}</p>
              </motion.div>
            );
          })}
        </div>
        <p className="mt-10 text-[11px] text-pearl/40 italic">
          Live · last refreshed {new Date(data.as_of).toLocaleString("en-GB")}
        </p>
      </div>
    </section>
  );
}
